import { FunctionComponent, useCallback } from "react";

import { useTranslation } from "react-i18next";

import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { Modal } from "@/components/Modals/Modal";

export interface RestartProcessingModalProps {
	isOpened: boolean;
	isLoading: boolean;
	handleClose: () => void;
	handleConfirm: () => void;
}

/**
 * Offered after mapping a file onto a list that has already finished (PREC-3091).
 *
 * A scraping list is ONCE: once its run completes it never starts again on its own, so without
 * this the freshly delivered file would stay mapped and idle forever.
 */
export const RestartProcessingModal: FunctionComponent<RestartProcessingModalProps> = ({
	isOpened,
	isLoading,
	handleClose,
	handleConfirm,
}) => {
	const { t } = useTranslation();
	const ts = useCallback((key: string) => t(`customEvent.rescrape.restart.${key}`), [t]);

	return (
		<Modal
			handleClose={handleClose}
			handleSave={handleConfirm}
			isLoading={isLoading}
			isOpened={isOpened}
			size="sm"
			submitButtonText={ts("confirm")}
			title={ts("title")}
		>
			<div className="flex flex-col gap-4">
				<div className="text-sm text-text-meta">{ts("description")}</div>

				<div className="flex flex-row items-start gap-2 rounded-xl bg-status-success-light px-4 py-3 text-xs text-status-success">
					<Icon className="w-[14px] h-auto shrink-0 mt-0.5" icon={faCircleCheck} />
					<span>{ts("scope")}</span>
				</div>

				<div className="text-xs text-text-meta">{ts("later")}</div>
			</div>
		</Modal>
	);
};
